import type { CSSProperties, ReactNode } from "react"

import { Container } from "../components"
import { cn } from "../ui"

interface ImageWithTextStyleProperties extends CSSProperties {
    ["--background"]: string
    ["--button-text-color"]: string
    ["--button-background"]: string
    ["--button-border"]: string
    ["--text-color"]: string
}
export const ImageWithText = ({
    className,
    background,
    button_text_color,
    button_background,
    button_border,
    mobile_image_down,
    desktop_image_right,
    imageBlock,
    textBlock,
    text_color,
}: {
    className?: string
    background?: string
    button_text_color?: string
    button_background?: string
    button_border?: string
    mobile_image_down?: boolean
    desktop_image_right?: boolean
    text_color?: string
    imageBlock: ReactNode
    textBlock: ReactNode
}) => {
    const style: ImageWithTextStyleProperties = {
        "--background": background || "transparent",
        "--button-text-color": button_text_color || "white",
        "--button-background": button_background || "transparent",
        "--button-border": button_border || "transparent",
        "--text-color": text_color || "inherit",
    }
    return (
        <div className={cn(className, "bg-[var(--background)]")} style={style}>
            <Container>
                <div
                    className={cn(
                        "flex gap-10 p-4 lg:items-center lg:p-20",
                        mobile_image_down ? "flex-col-reverse" : "flex-col",
                        desktop_image_right ? "lg:flex-row-reverse" : "lg:flex-row"
                    )}>
                    <div className="flex-1">{imageBlock}</div>
                    <div className="flex-1">{textBlock}</div>
                </div>
            </Container>
        </div>
    )
}
